import { METER_TYPES, MeterType, Usage } from '@boltenergy-be/shared'

/**
 * Returns the total volume based on the meter type
 * @param {MeterType} meterType
 * @param {MeterUsage} meterUsage
 * @returns {number}
 */
export const getTotalElectricityVolumeForMeterType = (meterType: MeterType, meterUsage: Usage): number => {
  const { double, exclusiveNight, single } = meterUsage?.electricity?.consumption

  if (meterType === METER_TYPES.double) {
    return Number(double?.day ?? 0) + Number(double?.night ?? 0) + Number(exclusiveNight ?? 0)
  }

  return Number(single ?? 0) + Number(exclusiveNight ?? 0)
}

/**
 * Returns the total volume based on the meter type
 * @param {MeterType} meterType
 * @param {MeterUsage['electricity']['injection']} injection
 * @returns {number}
 */
export const getTotalInjectionVolumeForMeterType = (meterType: MeterType, injection: Usage['electricity']['injection']): number => {
  const { double, single } = injection

  if (meterType === METER_TYPES.double) {
    return Number((double?.day ?? 0) + (double?.night ?? 0))
  }

  return Number(single ?? 0)
}

/**
 * Calculates the CO2 avoidance based on the total electricity volume and a fixed factor of 181.3 gCO2/kWh.
 * @param {MeterType} meterType
 * @param {Usage} usage
 * @returns {number}
 */
export const getCo2AvoidanceForElectricityVolume = (meterType: MeterType, usage: Usage): number => {
  const totalElVolume = getTotalElectricityVolumeForMeterType(meterType, usage)
  return (totalElVolume * 181.3) / 1000
}
